"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMessage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var icon_1 = require("../icon");
var config_context_1 = require("../_util/config-context");
exports.ModalMessage = react_1.default.forwardRef(function ModalMessage(_a, ref) {
    var icon = _a.icon, message = _a.message, description = _a.description, className = _a.className, props = tslib_1.__rest(_a, ["icon", "message", "description", "className"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-media", className) }, props),
        icon && (react_1.default.createElement("div", { className: classPrefix + "-media__left" },
            react_1.default.createElement(icon_1.Icon, { type: icon, size: "l" }))),
        react_1.default.createElement("div", { className: classPrefix + "-media__body" },
            message && (react_1.default.createElement("h3", { className: classPrefix + "-dialog__messagetitle" }, message)),
            description && (react_1.default.createElement("div", { className: classPrefix + "-dialog__messagetext" }, description)))));
});
exports.ModalMessage.displayName = "ModalMessage";
//# sourceMappingURL=ModalMessage.js.map